// common util types and constants
var NullItem = {
  id: '',
  label: '',
  value: null
};
var EmptyRecord = {};
var CSS_UNITS = ['px', '%', 'em', 'rem', 'vw', 'vh', 'vmin', 'vmax'];
var PercentageUnit = '%';
export { CSS_UNITS, EmptyRecord, NullItem, PercentageUnit };